import { createStore } from 'vuex';
import { Platform } from 'quasar';

const store = createStore({
    state: {
        userData: {
            company: '',
        },
        isSidebarOpen: Platform.is.desktop,
    },
    mutations: {
        updateUserData(state, userData) {
            state.userData = userData;
        },
        toggleSidebar(state) {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
    },
    actions: {
    },
    modules: {
    },
    getters: {
        userData: (state) => state.userData,
        isSidebarOpen: (state) => state.isSidebarOpen,
    },
    strict: process.env.DEBUGGING,
});

export default store;
